import { apiClient } from "./client";
import type { BusinessProfile } from "@abejon/shared";

interface BusinessResponse {
  business: BusinessProfile;
}

export async function getMyBusinesses() {
  return apiClient<{ businesses: BusinessProfile[] }>("/businesses?mine=true");
}

export async function createBusiness(data: {
  displayName: string;
  category: "barber" | "stylist" | "nail_tech";
  phone?: string;
  bio?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  latitude?: number;
  longitude?: number;
  timezone?: string;
}) {
  return apiClient<BusinessResponse>("/businesses", {
    method: "POST",
    body: data,
  });
}

export async function getBusiness(slug: string) {
  return apiClient<{ business: BusinessProfile & { ownerName: string; ownerAvatar: string | null } }>(
    `/businesses/${slug}`
  );
}

export async function updateBusiness(slug: string, data: Record<string, unknown>) {
  return apiClient<BusinessResponse>(`/businesses/${slug}`, {
    method: "PATCH",
    body: data,
  });
}
